import { render, staticRenderFns } from "./PlaylistForm.vue?vue&type=template&id=0c77fba3"
import script from "./PlaylistForm.vue?vue&type=script&lang=js"
export * from "./PlaylistForm.vue?vue&type=script&lang=js"
import style0 from "./PlaylistForm.vue?vue&type=style&index=0&id=0c77fba3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports